export const GAGoalsFeaturesDataMapping = {
  ai_response: {
    event_category: 'JusIA',
    event_action: 'View AI lock',
  },
  copy_juris_content: {
    event_category: 'Jurisprudência',
    event_action: 'View copy lock',
  },
  download_juris_content: {
    event_category: 'Jurisprudência',
    event_action: 'View download lock',
  },
  copy_diarios_content: {
    event_category: 'Diários',
    event_action: 'View copy lock',
  },
  download_diarios_content: {
    event_category: 'Diários',
    event_action: 'View download lock',
  },
  copy_modelos_content: {
    event_category: 'Modelos e Peças',
    event_action: 'View copy lock',
  },
  download_modelos_content: {
    event_category: 'Modelos e Peças',
    event_action: 'View download lock',
  },
  legal_quote: {
    event_category: 'Jurisprudência',
    event_action: 'Ementa copy lock',
  },
} as const satisfies Record<string, { event_category: string; event_action: string }>

export enum PlanFrequency {
  MONTHLY = 'mês',
  YEARLY = 'ano',
}

export enum PlanFrequencyLabel {
  MONTHLY = 'Mensal',
  YEARLY = 'Anual',
}
